"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPriorityOption = exports.StyledPriorityOptionLabel = exports.StyledPriorityOptionContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledPriorityOptionContent = styled_components_1.default.div `
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;
exports.StyledPriorityOptionLabel = styled_components_1.default.span `
  font-size: inherit;
  line-height: inherit;
  white-space: nowrap;
`;
exports.StyledPriorityOption = styled_components_1.default.div `
  display: inline-flex;

  .priority-flag-icon {
    font-size: 20px;
  }
`;
